exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n  width:100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\ndiv.content{\n  display:-webkit-box;\n  display:-ms-flexbox;\n  display:flex;\n  width:83.34%;\n  height: calc(100vh - 50px);\n  overflow: auto;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n\ndiv.footer{\n  text-align: center;\n  margin-top: auto;\n  padding-top: 15px;\n  margin-bottom: 20px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/wiserisk-core/src/main/ng4app/src/app/components/site/site.component.css
// module id = ../../../../../src/app/components/site/site.component.css
// module chunks = main